// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EntityAvatar_wrapper__1dZCR","avatar":"EntityAvatar_avatar__3db-l","title":"EntityAvatar_title__2FwCr"};